import '../sass/project.scss';

import 'htmx.org';
import './includes/theme';
import './includes/sidebar';

import './includes/modal';
import './includes/upload';
import './includes/toast';

import { productComponent, searchComponent } from './includes/typeahead';
import Alpine from 'alpinejs';

window.searchComponent = searchComponent;
window.productComponent = productComponent;

Alpine.directive('currency', (el, { modifiers }) => {})


window.htmx = require('htmx.org');
window.htmx.config.refreshOnHistoryMiss = true;
window.htmx.config.scrollIntoViewOnBoost = false;
window.Alpine = Alpine;
Alpine.start();


  window.addEventListener('DOMContentLoaded', () => {
    window.addEventListener('htmx:load', () => {
document.querySelectorAll(".list-container").forEach(container => {
  const btn = container.querySelector(".js-toggle");

  if (!btn) return;

  const items = container.querySelectorAll(".js-list li:not(:first-child)");

  let expanded = false;
if (items.length === 0) {
  btn.style.display = "none";
}
  btn.addEventListener("click", () => {
    expanded = !expanded;

    items.forEach(li => {
      li.style.display = expanded ? "list-item" : "none";
    });

    // btn.textContent = expanded ? "Show less" : "Read more";


  });
});
})})
